<template>
  <div class="container mescroll-touch" id="toTop">
    <div class="navigationBar">
      <div class="nav-left">
        <img class="arrow-left" @click="goback" src="@/assets/images/arrow-left.png" />
      </div>
      <div class="nav-title">更多</div>
      <div class="nav-right"></div>
    </div>
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="list" id="dataList">
        <div class="listItem" v-for="(item, index) in list" :key="index" @click="contentClick(item)">
          <img class="cover" :src="item.FileUrl" />
          <div class="info">
            <p class="title van-multi-ellipsis--l2">{{ item.Title }}</p>
            <p class="time" v-if="item.ArtType == 3">{{ item.StratTime }}</p>
            <div class="doctorInfo" v-if="item.SpeakerName">
              <img src="@/assets/images/headSculpture1.png" />
              <span class="doctorName">{{ item.SpeakerName }}</span>
              <span class="hospital van-ellipsis">{{ item.SpeakerHospital }}</span>
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  data() {
    return {
      hasPath: '',
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			}
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    zoneDetailsId() {
      return this.$route.query.zoneDetailsId
    },
    id() {
      return this.$route.query.id
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
      this.BuriedPoint(6, '专区更多列表', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''), this.zoneDetailsId, '', '');
  },
  methods: {
    mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Zone/GetZDCSList', {
          ZDCSId: this.id,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        })
      }, 200);
    },
    contentClick(info) {
      if(info.Type == 1 && info.LinkUrl) {
        location.href = info.LinkUrl;
      } else if (info.Type == 2) {
        if(info.ArtType == 1 || info.ArtType == 2) {
          this.$router.push({
            path: 'contentPage',
            query: {
              id: info.ArtId,
              type: info.ArtType,
              sourceType: 12,
              sourceId: this.zoneDetailsId
            }
          });
        } else if(info.ArtType == 3) {
          this.$router.push({
            path: 'liveDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.zoneDetailsId
            }
          });
        } else if(info.ArtType == 4) {
          this.$router.push({
            path: 'activityDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.zoneDetailsId
            }
          });
        }
      }
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #F3F3F3;
  box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 6px 0px;
  .nav-left {
    width: 80px;
    .arrow-left {
      display: block;
      width: 22px;
    }
  }
  .nav-title {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 25px;
    font-size: 12px;
  }
}
.mescroll {
  position: fixed;
  top: 50px;
  bottom: 0;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
}
.list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px; /* 间距统一 */
  .listItem {
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    border-radius: 10px;
    overflow: hidden;
    .cover {
      display: block;
      width: 100%;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px;
      .title {
        font-size: 12px;
        color: #1A1200;
      }
      .time {
        font-size: 10px;
        color: #898989;
        margin-top: 3px;
      }
      .doctorInfo {
        display: flex;
        align-items: center;
        border-top: 1px solid #D8D8D8;
        margin-top: 5px;
        padding-top: 5px;
        font-size: 10px;
        img {
          display: block;
          width: 20px;
        }
        .doctorName {
          white-space: nowrap;
          color: #373737;
          margin: 0 4px;
        }
        .hospital {
          color: #7A7A7A;
        }
      }
    }
  }
}
</style>